import React, { useState, useEffect} from 'react';
import styles from './country-beneficiaries.module.scss';
import { DataGrid } from 'devextreme-react/data-grid';

export interface IBeneficiariesDetailProps {
  data: any;
  presenter: any;
  renderColumn: any;  
  duplicatesSP: any;
  pivotData: any;
}

const CountryDetail: React.FC<IBeneficiariesDetailProps> = (props: IBeneficiariesDetailProps) => {
  const [columns, setColumns] = useState([])
  const [dataSource, setDataSource] = useState([])

  useEffect(() => {
    let detailAux = props.presenter.getDataDetails(props.data);
    setColumns(detailAux.columns);
    setDataSource(detailAux.dataSource);
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={styles.detailTitle}>
        {props.presenter.currentLabels.get("SuperposicionBeneficiarios")}
      </div>
      <DataGrid
        {...props.presenter.getGridPropsDetails(props.data)}
        dataSource={dataSource}
        showBorders={true}
        columnAutoWidth={true}
        onRowUpdated={() => props.presenter.saveDetail(dataSource, props.data)}
      >
        {columns.map((col: any) => props.renderColumn(col, props.data, dataSource))}
      </DataGrid>
    </>
  )
}

export default CountryDetail
